export interface ChatMsgState {
    chatMsg: ChatMsg[];
    showLoading: boolean;
    haveNotify: boolean;
    frontendAction?: FrontendActionInfo;
    activeContext?: string[];
    suggestionInput?: string;
}

export const initialChatMsgState: ChatMsgState = {
    chatMsg: [],
    showLoading: false,
    haveNotify: false,
    suggestionInput: ""
}

export interface ChatMsg {
    msg: string | DetectIntentData;
    type?: string;
    date?: Date;
    isHistoryMsg?: boolean;
    convId?: number;
    intentType?:string;
    parentQuery?: string;
}

export interface DetectIntentReq {
    message: string;
    name?: string;
    needSaveHistory?: string;
    frontendActionInfo?: FrontendActionInfo;
    notSaveToMongo?: boolean;
    exactMatch?: boolean;
    suggestion?: boolean;
    type?:string;
    covStartUrl?: string;
    forceLanguage?:string;
    language?:string;
    encodeFlag?: boolean;
}

export interface FormButtonValue {
    formMethod: string;
    formId: string;
    formAction: string;
    formTarget:string;
    formParameters: FormButtonParams[]
}

export interface FormButtonParams {
    tag: string;
    tagType: string;
    tagName: string;
    tagValue:string;
    tagText:string;
}

export interface DetectIntentData {
    fulfillmentMessages: FulfillmentMessages[];
    intentCode?:string;
    activeContext?:string[];
    intentContext?:string[];
}

export interface FulfillmentMessages {
    quickResponses?: QuickResponse;
    richResponse?: RichResponse;
}

interface QuickResponse {
    text?: string;
    julianConfidence?: number;
    googleConfidence?: number;
    buttons: Button[];
    html: string;
    action?: FrontendActionInfo;
}

export interface Button {
    // dataPayload?: any;
    intentCode?: string;
    postback: string;
    text: string;
    type?: string;
    url?: string;
    action?: FrontendActionInfo;
    styleType?: string;
    fileName?: string;
}

export interface Article {
    image?: string;
    title?: string;
    subtitle?: string;
    btn?: {
        text?: string;
        url?: string;
    }
}

interface IntentPayload {
    articles?: Article[] | Article;
    suggestions?: string;
}

export interface RichResponse {
    text?: string;
    julianConfidence?: number;
    googleConfidence?: number;
    buttons: Button[];
    html: string;
    form?: boolean;
    intent_payload?: IntentPayload;
    is_welcome?: boolean;
    search_results?: SearchResult[];
    getErrorFromCallBack?: boolean;
    action?: FrontendActionInfo;
}

interface SearchResult {
    documentName: string;
    documentDescription: string;
    documentSnippet: string;
    documentPage: string;
    documentDate: string;
    documentUrl: string;
    documentSite: string;
}

export interface ConversationSessionResp {
    conversationSessionId: string;
}

export interface UserMsgProps {
    userMsg: string | DetectIntentData;
    date?: Date | undefined;
}

export interface BuddyMsgProps {
    buddyMsg: string | DetectIntentData;
    date?: Date | undefined;
    isHistoryMsg?: boolean;
    convId?:number;
    disableBtn?: boolean;
    intentType?:string;
}

export interface BuddyCommonProps {
    buddyCommon: string | DetectIntentData;
    date?: Date | undefined;
}

export interface ChatTimeProps {
    date?: Date | string;
}

export interface FrontendActionInfo {
    id: string,
    name: string,
    param: string,
    actionCode: string
}

export interface ActionParamAuth {
    title: string;
    type: string;
    name: string;
    length: string;
    actionId: string;
}

export interface ControlFlow {
    success: string;
    fail: string;
}

export interface ChatAuthBtns {
    title: string;
    actionCode: string;
    controlFlow?:ControlFlow;
}
export interface ChatAuthFormProps {
    type: string;
    paramForm?: ActionParamAuth[];
    isHistoryMsg: boolean;
    btns?: ChatAuthBtns[];
    actionId?: string;
}

export interface ChatOTPBtns {
    title: string;
    actionCode: string;
    controlFlow?:ControlFlow;
}

export interface ChatOTPFormProps {
    type: string;
    isHistoryMsg: boolean;
    btns: ChatOTPBtns[];
    actionId?: string;
}

export interface ReportUserAction {
    buttonText: string;
    buttonUrl: string;
}

export interface DownloadByButtonReq {
    buttonUrl: string;
    fileName?: string;
}